<template>
    <div>
       <v-container>



         <v-text-field v-if="generals==undefined" color="primary" loading
                                                          disabled></v-text-field>


                <ul >
                        <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                       <span style="font-size: 20pt"> - </span> {{$t('generalsetting.anmr')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                       <v-switch v-model="generalsettings.anmr" :label="generalsettings.anmr?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                        </li>




                         <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                       <span style="font-size: 20pt"> - </span>
                                        {{$t('generalsetting.antrs')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                       <v-switch v-model="generalsettings.antrs" :label="generalsettings.antrs?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                        </li>

                         <li>
                                <v-row>
                                    <v-col md="10" sm="10" style="margin-top: 0.1%;">
                                       <span style="font-size: 20pt"> - </span>
                                       {{$t('generalsetting.ante')}}
                                    </v-col>

                                    <v-col md="2" sm="2" style="margin: 0%; padding: 0%;">
                                       <v-switch v-model="generalsettings.ante" :label="generalsettings.ante?'ON':'OFF'"></v-switch>
                                    </v-col>
                                </v-row>
                        </li>

                </ul>

                <v-row>
                    <v-spacer></v-spacer>


                    <v-btn :disbled="submitting" style="margin-right: 2%" color="primary"  @click.prevent="save(1)">

                        <span v-if='!submitting'>{{$t('save')}} </span>
                        <span v-else><v-progress-circular
                          :width="1"
                          color="white"
                          indeterminate
                          :size="25"
                        ></v-progress-circular> {{$t('saving')}} </span>

                    </v-btn>
                </v-row>


       </v-container>

       <customsnackbar :snackbar="customSnack.snackbar"
       :text="customSnack.text"
       :snackcolor="customSnack.snackcolor" :snackbBtnColor="customSnack.snackbBtnColor"
       :snacktimeout="customSnack.snacktimeout" > </customsnackbar>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import helpers from "../../../../mixins/helpers";


    export default {
        name: "GeneralSetting",
        mixins:[helpers(this)],
        data (){
            return{
              customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                  },
            snackbar: false,
            text: '',
                submitting: false,

              generalsettings:{
                anmr:false,
                antrs:false,
                ante:false
              },
              errors:undefined
            }
        },
        computed:{
          ...mapState('generalsettings/',['generals']),
        },
        mounted() {

           this.$store.dispatch('generalsettings/getGeneralSetting').then(response => {
                    console.log('getGeneralSetting',response)
                    this.generalsettings = response.generalsettings;
                    this.generalsettings.oldupt = response.generalsettings.upt;
                    this.generalsettings.olduct = response.generalsettings.uct;
                });

                this.$store.dispatch('langues/getLangues').then(response=>{console.log(response)});

        },
        methods:{

                loadsub(pos,state){
                     switch(pos)
                    {
                        case 1:
                            this.submitting = state;
                        break;

                        case 2:
                            this.submitting2 = state;
                        break;

                        case 3:
                            this.submitting3 = state;
                        break;


                    }
                },

             save(pos) {
                  this.customSnack.snackbar = false;
                 this.loadsub(pos,true);

                let data = new FormData();
                data.append("generalsettings", JSON.stringify(this.generalsettings));
                data.append("upt",this.generalsettings.upt);
                data.append("uct", this.generalsettings.uct);
                if(pos==3)
                {
                        if(this.generalsettings.uct.name)
                        {
                            if(this.generalsettings.uct.name.split('.').pop()!="pdf")
                            {
                                 this.loadsub(pos, false);
                                    this.snackbar = true;
                                    this.text = "Fichier PDF requis";
                                return 0;
                            }
                        }

                        if(this.generalsettings.upt.name)
                        {
                            if(this.generalsettings.upt.name.split('.').pop()!="pdf")
                            {
                                 this.loadsub(pos, false);
                                    this.snackbar = true;
                                    this.text = "Fichier PDF requis";
                                return 0;
                            }
                        }
                }
                let mineroute = 'generalsettings/updateGeneralSetting';
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log("response",response);
                    this.loadsub(pos, false);
                    this.showSnackDefault(response);
                    if(!response.data.error)
                    {
                        this.generalsettings = response.data.generalsettings;
                        this.generalsettings.oldupt = response.data.generalsettings.upt;
                        this.generalsettings.olduct = response.data.generalsettings.uct;
                    }

                })
            },
        },
    }

</script>

<style scoped>
  ul {
    font-size: 12pt;

   list-style-type: none;
}

li{
    margin-top: 1.8%;
}


</style>
